module.exports = __webpack_public_path__ + "img/espaco4.974d0bdd.jpeg";